<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19.6" height="24" viewBox="0 0 19.6 24">
    <g id="clipboard" transform="translate(1 1)">
      <path
        id="Path_4890"
        data-name="Path 4890"
        d="M16.6,3.2a2.2,2.2,0,1,0-4.4,0H10V6.133h8.8V3.2Z"
        transform="translate(-5.6 -1)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        id="Path_4891"
        data-name="Path 4891"
        d="M19.4,5h2.2V24.067H4V5H6.2"
        transform="translate(-4 -2.067)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <line
        id="Line_317"
        data-name="Line 317"
        x2="11"
        transform="translate(3.3 9.9)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-width="1"
      />
      <line
        id="Line_318"
        data-name="Line 318"
        x2="11"
        transform="translate(3.3 13.567)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-width="1"
      />
      <line
        id="Line_319"
        data-name="Line 319"
        x2="11"
        transform="translate(3.3 17.233)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-width="1"
      />
    </g>
  </svg>
</template>
